module.exports = __webpack_public_path__ + "img/expand.a47db4a5.svg";